<template>
  <BaseNoticeItem>
    <template #head>
      <strong>{{ $t('PAYE contracts must have clear start and end dates') }}</strong>
    </template>
    <template #body>
      {{
        $t(
          'This contract is missing start or end dates, which are needed in order to payroll you. So before you can create a bill on this contract, please contact your client to ensure that the dates get added.',
        )
      }}
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useTranslation } from '@/composables/translation'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})

const { $t } = useTranslation()
</script>
